import React from "react";
import { Col, Row } from "reactstrap";
import StatBox from "./StatBox";
import './index.scss';

const StatsBlock = (
	{
		className = '',
		handleView,
		toggletabindex,
		settoggletabindex,
		totalFilesProcessedToday,
		filesProcessedLoading,
		totalFilesProcessedYesterday,
		totalFilesEditedToday,
		filesEditedLoading,
		totalFilesEditedYesterday,
		averageComputeTimeToday,
		averageComputeTimeLoading,
		averageComputeTimeYesterday
	}
) => {
	
	const toggle = tab => {

		if (toggletabindex !== tab) settoggletabindex(tab);
	}
	return (
		<>
			<div className={`stats-blc ${className}`} onClick={handleView}>
				<Row className="stats-blc-rw">
					<Col md="6" lg="3" onClick={() => { toggle(0);}}>
						
						<StatBox
							label="FILES PROCESSED TODAY"
							todayData={totalFilesProcessedToday}
							yesterdayData={totalFilesProcessedYesterday}
							profit
							loading={filesProcessedLoading}
							icon
							custom
							iconColor
							text="than yesterday"
							className={`top-bar ${toggletabindex === 0 ? 'active' : ''}`}
						/>
					</Col>
					<Col md="6" lg="3" onClick={() => { toggle(1);}}>
						<StatBox
							label="MANUALLY CHECKED ITEMS TODAY"
							todayData={totalFilesEditedToday}
							yesterdayData={totalFilesEditedYesterday}
							profit
							loading={filesEditedLoading}
							iconColor
							custom
							text="than yesterday"
							icon
							className={`top-bar ${toggletabindex === 1 ? 'active' : ''}`}
						/>
					</Col>
					<Col md="6" lg="3">
						<StatBox
							label="ENDPOINTS UP"
							value="6/6"
							loading={false}
							 />
					</Col>
					<Col md="6" lg="3">
						<StatBox
							label="AVG. COMPUTE TIME TODAY"
							todayData={averageComputeTimeToday/1000}
							yesterdayData={averageComputeTimeYesterday/1000}
							profit
							loading={averageComputeTimeLoading}
							icon
							second={true}
							text="than yesterday"
							iconColor="text-success"
						/>
					</Col>
				</Row>
			</div>
		</>
	);

}
export default StatsBlock;